import { useQuery } from '@tanstack/react-query';
import { request, gql } from 'graphql-request';

import { QueryKeys } from 'src/constants/queryKeys';

import { PoolToken } from '@app/types/pool';
import { getLastDayTimestamp } from '@app/helpers/format';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';

type QueryParams = {
  tokenIds: string | undefined;
};

type Response = {
  address: string;
  liquidity: string;
  price: string;
  tick: string;
  token0: PoolToken;
  token1: PoolToken;
};

function getQuery(queryParams: QueryParams) {
  return gql`
    query {
      tokens(
        where: {
          id_in: [${queryParams.tokenIds}]
        }
      ) {
        id
        symbol
        name
        decimals
        derivedMatic
        totalValueLocked
        totalValueLockedUSD
        tokenDayData(
          where: {
            date_gte: ${getLastDayTimestamp()}
          }
        ) {
          date
          volumeUSD
        }
      }
    }
  `;
}

export const fetcher = async (
  queryParams: QueryParams,
  config: ApplicationConfig | undefined
) => {
  const query = getQuery(queryParams);

  const res = await request<{ tokens: PoolToken[] }>(
    `${config?.URLS.subgraphUrlV3}`,
    query,
    queryParams
  );

  return res.tokens;
};

export function useMultipleTokensQuery(params: QueryParams) {
  const config = useConfig();

  return useQuery<PoolToken[] | undefined>(
    [QueryKeys.MULTIPLE_TOKENS, { params }],
    () => {
      return fetcher(params, config);
    },
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      enabled: !!(params.tokenIds && config)
    }
  );
}
